import { render, staticRenderFns } from "./BillingTable.vue?vue&type=template&id=60eb39e5&scoped=true"
import script from "./BillingTable.vue?vue&type=script&lang=js"
export * from "./BillingTable.vue?vue&type=script&lang=js"
import style0 from "./BillingTable.vue?vue&type=style&index=0&id=60eb39e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eb39e5",
  null
  
)

export default component.exports